import { Pipe, PipeTransform, NgModule } from '@angular/core';

type AnyArray = unknown[];

@Pipe({ name: 'chunk', standalone: false })
export class ChunkPipe implements PipeTransform {
  /**
   * Splits an array into chunks of a given size
   * @param input - The array to chunk
   * @param size - The chunk size
   * @returns Array of chunked arrays
   */
  transform(input: AnyArray | undefined | null, size = 1): unknown[][] {
    if (!Array.isArray(input)) {
      return [];
    }
    return ([] as unknown[][]).concat(
      ...input.map((_elem: unknown, i: number) => {
        return i % size ? [] : [input.slice(i, i + size)];
      })
    );
  }
}

@NgModule({
  declarations: [ChunkPipe],
  exports: [ChunkPipe],
})
export class NgChunkPipeModule {}
